/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Un vídeo/partido donde participó el equipo.
 */
export interface TeamVideoDTO { 
    video_id: string;
    video_title: string;
    video_date?: string | null;
    total_scenes: number;
    opponent_team_id?: string | null;
    opponent_team_name?: string | null;
}

